import { Grid, HStack, Text } from '@chakra-ui/react';

import ReactGA from 'react-ga4';
import {
  checkForSubQuestion,
  getTextFromPreviousAnswer,
} from '../../handlers/utils';
import Menu from '../../formSections/Menu';
import PFSWrapper from './PFSWrapper';
import {
  onSubmit,
  onLink,
  isMultiSection,
  getResumeOrSectionIndex,
  canSubmit, download,

} from '../../handlers';
import { Button } from '@chakra-ui/react';
import PFSNav from './PFSNav/index.jsx';
import { getIndustryPE, nextToBulletBank } from '../../formElements/Bullets/utils';
import { fillInBulletsFromAI } from '../../formElements/Bullets/Navigation/utils';
import { getIndustry } from '../../formSections/Start/utils';
import JobIndustryModal from '../Modal/JobIndustryModal';
import { getUsefulVars } from '../../handlers/helpers';
import { InterviewUtils } from '../../formSections/Interview/utils';
import { handleAptitudeResults } from '../../formSections/Aptitude/utils';
import { parseCoverLetter } from '../../formSections/Parser/utils';


export const interpolateHiddenField = (props, qObj) => {
  qObj.hidden = true;
  const jobSeekerData = props.formikProps.values.jobSeekerData;
  const secIndex = props.stateProps.sectionData.sectionIndex;
  jobSeekerData[secIndex][qObj.qid] = getTextFromPreviousAnswer(
    qObj.answers,
    props,
  );
};

export const getNextStep = (
  props,
  groupedQuestions,
  nextStep,
  secOrIndIndex,
) => {
  nextStep++;
  if (nextStep < groupedQuestions.length) {
    const testGroup = Array.isArray(groupedQuestions[nextStep])
      ? groupedQuestions[nextStep]
      : [groupedQuestions[nextStep]];

    for (let i = 0; i < testGroup.length; i++) {
      const qObj = testGroup[i];
      if (qObj.question_type === 'hidden') {
        interpolateHiddenField(props, qObj);
        nextStep = getNextStep(
          props,
          groupedQuestions,
          nextStep,
          secOrIndIndex,
        );
      }
      if (
        typeof qObj.is_subquestion !== 'undefined' &&
        qObj.conditionalGroups.length > 0
      ) {
        const found = checkForSubQuestion(qObj, props, secOrIndIndex);
        if (!found) {
          if (
            typeof qObj.parent !== 'undefined' ||
            qObj.question_type === 'hidden'
          ) {
            qObj.hidden = true;
          } else {
            nextStep = getNextStep(
              props,
              groupedQuestions,
              nextStep,
              secOrIndIndex,
            );
          }
        }
      }
    }
  }
  return nextStep;
};

export const getSteps = (stepIndex, groupedQuestions) => {
  let currentStep = stepIndex + 1;
  let steps = groupedQuestions.length;

  for (const [i, question] of Object.entries(groupedQuestions)) {
    if (question['question_type'] === 'hidden' || question['question_type'] === 'bullets') {
      steps--;
      if (i < currentStep - 1) {
        currentStep--;
      }
    }
  }
  const qObj = groupedQuestions[currentStep - 1];
  return [currentStep, steps, qObj];
};

export const handleBack = (props, groupedQuestions, step) => {
  let prevStep = step;
  prevStep--;
  const qObj = groupedQuestions[prevStep];
  if (qObj.question_type === 'hidden') {
    interpolateHiddenField(props, qObj);
    prevStep--;
  }
  props.stateProps.setStep(step => prevStep);
};
export const handleSkip = (props, groupedQuestions, step, secOrIndIndex) => {

  const isNextToLastStep = step === groupedQuestions.length - 2;
  if (isNextToLastStep) {
    enterBulletBank(props, groupedQuestions, step, secOrIndIndex);
  } else {
    handleNext(props, groupedQuestions, step, secOrIndIndex);
  }
};
export const handleNext = (props, groupedQuestions, step, secOrIndIndex) => {
  if (groupedQuestions) {
    const qObj = groupedQuestions[step];
    const sectionIndex = props.stateProps.sectionData.sectionIndex;
    if ((typeof qObj.is_required !== 'undefined' && qObj.is_required === '1'
        //ALERT what is touched?  Why are we checking qid on line 128?
        && (props.formikProps.touched.jobSeekerData === undefined || props.formikProps.touched.jobSeekerData[0][qObj.qid] === undefined))
      || (props.formikProps.errors.jobSeekerData === undefined || props.formikProps.errors.jobSeekerData[sectionIndex] || undefined > 0 && props.formikProps.errors.jobSeekerData[sectionIndex][qObj.qid] === undefined)
    ) {

      const nextStep = getNextStep(props, groupedQuestions, step, secOrIndIndex);
      props.handlers.onSubmit(props.formikProps, props.stateProps);
      props.stateProps.setStep(step => nextStep);
    } else {
      const nextStep = getNextStep(props, groupedQuestions, step, secOrIndIndex);
      props.handlers.onSubmit(props.formikProps, props.stateProps);
      props.stateProps.setStep(step => nextStep);
    }
  }
};
export const handleAINext = (props, groupedQuestions, step, secOrIndIndex) => {
  // set_ai_opts(props.stateProps)
  handleNext(props, groupedQuestions, step, secOrIndIndex);
};
export const handleDoNotSubmit = (e, props) => {

};
export const handleDone = (e, props, uri = '') => {
  const saved = props.stateProps.dataToSave.saved;
  const resumeIndex = getResumeOrSectionIndex(
    props.stateProps,
    props.formikProps,
  );
  if (
    props.stateProps.sectionData.sectionName === 'professional-experience' &&
    (typeof saved.resumes[resumeIndex]['professional-experience'] ===
      'undefined' ||
      saved.resumes[resumeIndex]['professional-experience'].length < 2)
  ) {
    // props.stateProps.setMessageModal(true);
    // props.stateProps.onOpen(e);
    handleSubmit(props, uri);
  } else {
    handleSubmit(props, uri);
  }
};
/*
export const skipToBulletBank = (props, groupedQuestions, secOrIndIndex,urlPart='getGenericBullets') => {
  const stateProps = props.stateProps;
  const jobSeekerData = props.formikProps.values.jobSeekerData;
  const resumeIndex = stateProps.sectionData.resumeIndex;
  const indIndex = secOrIndIndex;//stateProps.sectionData.indIndex;
  const target_industry = stateProps.dataToSave.saved.resumes[resumeIndex]['industry'];
  const target_job_title = stateProps.dataToSave.saved.resumes[resumeIndex]['job_title'];
  const job_title = jobSeekerData[indIndex]['job_title'];
  const industry = jobSeekerData[indIndex]['industry'];
  const jobExperience = getJobExperience(jobSeekerData);
  const url = stateProps.domain + '/wp-json/rsworks/v1/'+urlPart;

  const request = {
    jobTitle: job_title,
    industry: industry,
    targetJobTitle: target_job_title,
    targetIndustry: target_industry[0],
    jobExperience: jobExperience,
  };
  const args = {
    props: props,
    jobSeekerData: jobSeekerData,
    job_title: job_title,
    industry:industry,
    target_job_title: target_job_title,
    targetIndustry:target_industry[0],
    jobExperience:jobExperience,
    firstMulti:true,
    urlPart:'getFillableBullets',
    message: 'Generate questions from AI',
  };
  if(args.props.stateProps.isSpinnerOpen) {
    args.props.stateProps.onSpinnerClose();
  }
 // runAxios(url, request, getFillableCallback, args);

};*/

const enterBulletBank = (props, groupedQuestions, step) => {
  const stateProps = props.stateProps;
  const jobSeekerData = props.formikProps.values.jobSeekerData;
  const indIndex = stateProps.sectionData.indIndex;
  const resumeIndex = stateProps.sectionData.resumeIndex;
  const target_job_title = stateProps.dataToSave.saved.resumes[resumeIndex]['job_title'];
  const job_title = jobSeekerData[indIndex]['job_title'];

  fillInBulletsFromAI(props, jobSeekerData, target_job_title, job_title, false, 'last');

};
const getShowSkip = (props) => {
  const uv = getUsefulVars(props);
  const sectionIndex = uv.stateProps.sectionData.sectionIndex;
  const sectionName = uv.stateProps.sectionData.sectionName;
  if (sectionName === 'professional-experience') {

    const pe = uv.resume['professional-experience'];
    const industry = (pe !== undefined && pe.length > 0) ? pe[sectionIndex]['industry'] : null;
    if (industry && !uv.resume.parsed) {
      return true;
    } else {
      return false;
    }
  }
  if (sectionName === 'resumes' || sectionName === 'parser' || sectionName === 'download') {
    return false;
  } else {
    return true;

  }
};
/**
 *
 * @param props
 * @param groupedQuestions
 * @param step
 * @param secOrIndIndex
 * @param isMultipart
 * @param isLastStep
 * @returns {JSX.Element}
 */
export const getSubmitButton = (
  props,
  groupedQuestions,
  step,
  secOrIndIndex,
  isMultipart,
  isLastStep,
  buttonStyles,
) => {
  const isNextToLastStep = step === groupedQuestions.length - 2;
  let continueText = 'Continue';
  let continueURI = 'menu';
  const sectionName = props.stateProps.sectionData.sectionName;
  const showSkip = getShowSkip(props);
  switch (sectionName) {
    case 'download':
      continueText = 'Save';
      continueURI = 'preview';
      break;
    case 'survey':
      continueText = 'Download';
      break;
    case 'parser':
      continueText = 'Parse';
      break;
    case 'parse-letter':
      continueText = 'Parse Letter';
      continueURI = 'preview-letter';
      break;
    case 'job-posting':
      continueText = 'Generate';
      break;
    default:
      continueText = 'Continuea';
  }
  if (isLastStep) {
    // since abandoning the modal error messages canSubmit always return true...
    // can be eliminated
    if (props.stateProps.sectionData.sectionName === 'new-aptitude') {
      return (
        <Button
          sx={{ ...buttonStyles.primary }}
          onClick={() =>
            handleAptitudeResults(props, groupedQuestions, step, secOrIndIndex)
          }
        >
          Generate
        </Button>
      );
    }
    if (canSubmit(props)) {
      if (
        props.stateProps.sectionData.sectionName === 'professional-experience'
      ) {
        const stateProps = props.stateProps;
        const industryqObj = stateProps.aiIndustryPEData.aiIndustryQObj;
        if (props.stateProps.sectionData.sectionType === 'section') {
          return (
            <>
              <HStack>
                <JobIndustryModal props={props} />
                {showSkip &&

                  <Button
                    sx={{ ...buttonStyles.primary }}
                    onClick={() =>
                      nextToBulletBank(props, secOrIndIndex)
                    }
                  >Next</Button>
                }
                {!showSkip &&
                  <Button
                    sx={{ ...buttonStyles.primary }}
                    onClick={() =>
                      getIndustryPE(
                        props, industryqObj,
                      )
                    }
                  >
                    Personalize
                  </Button>
                }
              </HStack>

            </>
          );
        } else {
          return (
            <Button
              onClick={() =>
                onLink(
                  false,
                  props.formikProps,
                  props.stateProps,
                  'professional-experience',
                  parseInt(props.stateProps.editableIndex) + 1,
                  'section',
                )
              }
            >
              <Text
                sx={{
                  fontSize: ['20px', '14px'],
                  fontWeight: 600,
                  align: 'center',
                  whiteSpace: ['wrap', 'initial'],
                  maxWidth: ['240px', '120px'],
                }}
              >
                Save
              </Text>
            </Button>
          );
        }
      } else {
        if (props.stateProps.sectionData.sectionName === 'resumes') {
          return (
            <Button
              sx={{ ...buttonStyles.primary, ...buttonStyles.backButton }}
              onClick={() =>
                getIndustry(props, secOrIndIndex)
              }
            >
              Continue
            </Button>
          );
        }
        //Interview end here.
        if (props.stateProps.sectionData.preview === 1 && props.stateProps.sectionData.sectionName !== 'job-posting') {
          return (<Button onClick={() => handlePreviewReturn(props, 'preview')}>Return
          </Button>);
        } else {

          if (sectionName === 'parser' || sectionName === 'interview-coacher' ) {
            return null;
          }
          return (
            <Button
              sx={{ ...buttonStyles.primary }}
              onClick={() => handleContinue(props, continueURI)}>{continueText}</Button>
          );
        }

      }
    } else {
      return (
        <Button onClick={e => handleDoNotSubmit(e, props)}>Continue</Button>
      );
    }
  } else {
    if (isNextToLastStep) {
      if (props.stateProps.sectionData.sectionName === 'interview-sparl') {
        const iu = new InterviewUtils(props);
        return (
          <Button
            sx={{ ...buttonStyles.primary }}
            onClick={() => (
              iu.handleInterviewResults(groupedQuestions, step, secOrIndIndex))
            }
          >
            Generate
          </Button>
        );
      }
      if (props.stateProps.sectionData.sectionName === 'grow-goals') {
        const iu = new InterviewUtils(props);
        return (
          <Button
            sx={{ ...buttonStyles.primary }}
            onClick={() => (
              iu.handleGrowResults(groupedQuestions, step, secOrIndIndex))
            }
          >
            Generate
          </Button>
        );
      }
      if (props.stateProps.sectionData.sectionName === 'interview-you') {
        const iu = new InterviewUtils(props);
        return (
          <Button
            sx={{ ...buttonStyles.primary }}
            onClick={() =>
              iu.handleInterviewYouResults(groupedQuestions, step, secOrIndIndex)
            }
          >
            Generate
          </Button>
        );
      }
      if (props.stateProps.sectionData.sectionName === 'interview-questions') {
        const iu = new InterviewUtils(props);
        return (
          <Button
            sx={{ ...buttonStyles.primary }}
            onClick={() =>
              iu.handleInterviewQuestionsResults(groupedQuestions, step, secOrIndIndex)
            }
          >
            Generate
          </Button>
        );
      }
      if (props.stateProps.sectionData.sectionName === 'professional-experience') {
        return (
          <Button
            sx={{ ...buttonStyles.primary }}
            onClick={() =>
              enterBulletBank(props, groupedQuestions, step)
            }
          >
            Next
          </Button>
        );
      } else {
        if (props.stateProps.sectionData.sectionName === 'career-profile') {
          return (
            <Button
              sx={{ ...buttonStyles.primary }}
              onClick={() =>
                handleAINext(props, groupedQuestions, step, secOrIndIndex)
              }
            >
              Next
            </Button>
          );
        } else {
          return (
            <Button
              sx={{ ...buttonStyles.primary }}
              onClick={() =>
                handleNext(props, groupedQuestions, step, secOrIndIndex)
              }
            >
              Next
            </Button>
          );
        }
      }
    } else {
      const sectionName = props.stateProps.sectionData.sectionName;
      if (sectionName === 'interview-sparl' || sectionName === 'interview-you' || sectionName === 'interview-questions' || sectionName === 'grow-goals') {
        const iu = new InterviewUtils(props);
        return (
          <Button
            sx={{ ...buttonStyles.primary }}
            onClick={() =>
              iu.handleInterviewNext(groupedQuestions, step, secOrIndIndex)
            }
          >
            Next
          </Button>
        );
      }
      return (
        <Grid templateColumns={2} display="flex" justifyContent="space-between">

          <Button
            sx={{ ...buttonStyles.primary }}
            onClick={() =>
              handleNext(props, groupedQuestions, step, secOrIndIndex)
            }
          >
            Next
          </Button>
        </Grid>
      );
    }

  }
};
export const handlePreviewReturn = (props, uri) => {
  handleContinue(props, uri);
};
export const handleContinue = (props, uri) => {
  if (props.stateProps.sectionData.sectionName === 'survey') {
    ReactGA.send({
      hitType: 'pageview',
      page: '/download',
      title: 'Download',
    });
    download(props);
  }
  //HIDE SURVEY HERE

  if (props.stateProps.sectionData.sectionName === 'job-posting') {
    parseCoverLetter(props);
  } else {
    props.formikProps.validateForm().then((status) => {
        if (Object.keys(status).length === 0) {
          handleSubmit(props, uri);
        } else {
          // alert ('NO!')
        }
      },
    );
  }
};

/**
 *
 * @param props
 * @param uri
 * @ALERT Why did the -1 on line 447 have to change to 0?
 */
export const handleSubmit = (props, uri) => {
  const sectionName = uri !== '' ? uri : props.stateProps.sectionData.sectionName;
  onSubmit(props.formikProps, props.stateProps);
  if (isMultiSection(props)) {
    props.stateProps.setEditableIndex(0);
    onLink(
      false,
      props.formikProps,
      props.stateProps,
      sectionName,
      0,
      'section',
    );
  } else {

    const section = typeof uri !== 'undefined' && uri !== '' ? uri : 'menu';
    onLink(false, props.formikProps, props.stateProps, section, 0);
  }
};
export const progressiveFormStepper = (
  props,
  groupedQuestions,
  secOrIndIndex,
  multi = false,
  columns = 1,
) => {
  //TODO: review
  const beyondLastStep =
    !multi && props.stateProps.step > groupedQuestions.length - 1;
  if (beyondLastStep) {
    if (props.handlers.isMultiSection(props)) {
      props.handlers.onLink(
        false,
        props.formikProps,
        props.stateProps,
        props.stateProps.sectionData.sectionName,
        -1,
      );
    } else {
      return (<Menu navSections={props.navSections} props={props} formikProps={props.formikProps} />);
    }
  } else {
    return (<PFSWrapper props={props} groupedQuestions={groupedQuestions} secOrIndIndex={secOrIndIndex} />);
  }
};
export const getQuestionCount = props => {
  const industry = 'other';
  const questions = props.survey.industry[industry].questions;
  const indIndex = props.stateProps.sectionData.indIndex;
  const questionCount = questions.length - 1;
  const answeredQuestions = props.formikProps.values.jobSeekerData[indIndex];
  let answeredQuestionCount = 0;
  for (const question of questions) {
    if (typeof answeredQuestions[question.qid] !== 'undefined') {
      answeredQuestionCount++;
    }
  }
  return [questionCount, answeredQuestionCount];
};

export const getPFSComponents = (
  props,
  groupedQuestions,
  secOrIndIndex,
  isMultipart,
) => {
  const step = props.stateProps.step;
  const isLastStep = step >= groupedQuestions.length - 1;
  const qGroup = isMultipart ? groupedQuestions : [groupedQuestions[step]];
  const pfsNav = isMultipart
    ? null
    : PFSNav(
      props,
      groupedQuestions,
      step,
      secOrIndIndex,
      isMultipart,
      isLastStep,
    );
  return [pfsNav, qGroup, step];
};
//JB Temp Skip to Bullet Bank removed.
